import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import VerificationCard from ".";
import { UseSelector } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/reducers";
import Button from "../../../../components/common/Button";
import './VerificationModal.css';

interface showModalProps{
    showModal:boolean;
    handleClose: ()=>void;
    handleVerify:(value:boolean,input:string)=>void;
}
const VerifyIndex: React.FC<showModalProps> = ({showModal,handleClose,handleVerify}) => {
   // const [show, setShow] = useState<boolean>(showModal);
     const closeLastCard = () => handleClose();

    const userType=useSelector((state:RootState)=>state.user.userType);
    const userDesignation = useSelector((state: RootState) => state.user.designation)
    
    return (
        <div>
            <div className="modal_abha_hfr_verification">
                <Modal
                    show={showModal}
                    onHide={handleClose}
                    dialogClassName={'verify-card-modal'}
                >
                    
                    <Modal.Body  >
                        <VerificationCard handleVerify={handleVerify} closeLastCard={closeLastCard} cardContent1Header={(userType==='Field Level User' &&  userDesignation !== 'MPW/MPHW') ?"HPR Verification":"ABHA Verification"} />
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    )
}
export default VerifyIndex;